export default __webpack_public_path__ + "static/full_arrow-6f9e8bf9f54a02ccb64e08c1f534e413.png";